module.exports = __webpack_public_path__ + "static/media/galerija_2016 (6).37f759a6.jpg";